/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiMemberDtoCustomListConnectionDto } from './WebApiMemberDtoCustomListConnectionDto';
import {
    WebApiMemberDtoCustomListConnectionDtoFromJSON,
    WebApiMemberDtoCustomListConnectionDtoFromJSONTyped,
    WebApiMemberDtoCustomListConnectionDtoToJSON,
} from './WebApiMemberDtoCustomListConnectionDto';
import type { WebApiMemberDtoCustomMemberFieldValueDto } from './WebApiMemberDtoCustomMemberFieldValueDto';
import {
    WebApiMemberDtoCustomMemberFieldValueDtoFromJSON,
    WebApiMemberDtoCustomMemberFieldValueDtoFromJSONTyped,
    WebApiMemberDtoCustomMemberFieldValueDtoToJSON,
} from './WebApiMemberDtoCustomMemberFieldValueDto';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import type { WebApiModelsEnumerationTypesMemberStatus } from './WebApiModelsEnumerationTypesMemberStatus';
import {
    WebApiModelsEnumerationTypesMemberStatusFromJSON,
    WebApiModelsEnumerationTypesMemberStatusFromJSONTyped,
    WebApiModelsEnumerationTypesMemberStatusToJSON,
} from './WebApiModelsEnumerationTypesMemberStatus';
import type { WebApiModelsEnumerationTypesMemberType } from './WebApiModelsEnumerationTypesMemberType';
import {
    WebApiModelsEnumerationTypesMemberTypeFromJSON,
    WebApiModelsEnumerationTypesMemberTypeFromJSONTyped,
    WebApiModelsEnumerationTypesMemberTypeToJSON,
} from './WebApiModelsEnumerationTypesMemberType';

/**
 * 
 * @export
 * @interface WebApiMemberDtoMemberDto
 */
export interface WebApiMemberDtoMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoMemberDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    email2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    unconfirmedEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    paymentLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    paymentLinkId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    invoiceUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    paymentLinkLastYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    paymentLinkIdLastYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    invoiceUrlLastYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    paymentLinkNextYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    paymentLinkIdNextYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    invoiceUrlNextYear?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoMemberDto
     */
    isPaidNextYear?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    postalArea?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    phoneNumberFormatted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    company?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    uniqueId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    extra1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    extra2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    extra3?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiMemberDtoMemberDto
     */
    groups?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebApiMemberDtoMemberDto
     */
    groupNames?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoMemberDto
     */
    numberOfNotes?: number;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoMemberDto
     */
    lastModified?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoMemberDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoMemberDto
     */
    isPaidCurrentYear?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberDtoMemberDto
     */
    isPaidLastYear?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberStatus}
     * @memberof WebApiMemberDtoMemberDto
     */
    status?: WebApiModelsEnumerationTypesMemberStatus;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiMemberDtoMemberDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberType}
     * @memberof WebApiMemberDtoMemberDto
     */
    memberType?: WebApiModelsEnumerationTypesMemberType;
    /**
     * For a family member: the primary member of the household. Null for regular members.
     * @type {number}
     * @memberof WebApiMemberDtoMemberDto
     */
    primaryMemberId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    personalNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    phoneNumber2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    phoneNumber2Formatted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    adressRow2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    adressRow3?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoMemberDto
     */
    joinedDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoMemberDto
     */
    webPage?: string | null;
    /**
     * 
     * @type {Array<WebApiMemberDtoCustomMemberFieldValueDto>}
     * @memberof WebApiMemberDtoMemberDto
     */
    customFieldValues?: Array<WebApiMemberDtoCustomMemberFieldValueDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoMemberDto
     */
    membershipProduct?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiMemberDtoMemberDto
     */
    membershipProductAddOn?: Array<number> | null;
    /**
     * 
     * @type {Array<WebApiMemberDtoCustomListConnectionDto>}
     * @memberof WebApiMemberDtoMemberDto
     */
    customListConnections?: Array<WebApiMemberDtoCustomListConnectionDto> | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoMemberDto interface.
 */
export function instanceOfWebApiMemberDtoMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoMemberDtoFromJSON(json: any): WebApiMemberDtoMemberDto {
    return WebApiMemberDtoMemberDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'email2': !exists(json, 'email2') ? undefined : json['email2'],
        'unconfirmedEmail': !exists(json, 'unconfirmedEmail') ? undefined : json['unconfirmedEmail'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'postalCode': !exists(json, 'postalCode') ? undefined : json['postalCode'],
        'paymentLink': !exists(json, 'paymentLink') ? undefined : json['paymentLink'],
        'paymentLinkId': !exists(json, 'paymentLinkId') ? undefined : json['paymentLinkId'],
        'invoiceUrl': !exists(json, 'invoiceUrl') ? undefined : json['invoiceUrl'],
        'paymentLinkLastYear': !exists(json, 'paymentLinkLastYear') ? undefined : json['paymentLinkLastYear'],
        'paymentLinkIdLastYear': !exists(json, 'paymentLinkIdLastYear') ? undefined : json['paymentLinkIdLastYear'],
        'invoiceUrlLastYear': !exists(json, 'invoiceUrlLastYear') ? undefined : json['invoiceUrlLastYear'],
        'paymentLinkNextYear': !exists(json, 'paymentLinkNextYear') ? undefined : json['paymentLinkNextYear'],
        'paymentLinkIdNextYear': !exists(json, 'paymentLinkIdNextYear') ? undefined : json['paymentLinkIdNextYear'],
        'invoiceUrlNextYear': !exists(json, 'invoiceUrlNextYear') ? undefined : json['invoiceUrlNextYear'],
        'isPaidNextYear': !exists(json, 'isPaidNextYear') ? undefined : json['isPaidNextYear'],
        'postalArea': !exists(json, 'postalArea') ? undefined : json['postalArea'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'phoneNumberFormatted': !exists(json, 'phoneNumberFormatted') ? undefined : json['phoneNumberFormatted'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'extra1': !exists(json, 'extra1') ? undefined : json['extra1'],
        'extra2': !exists(json, 'extra2') ? undefined : json['extra2'],
        'extra3': !exists(json, 'extra3') ? undefined : json['extra3'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'groupNames': !exists(json, 'groupNames') ? undefined : json['groupNames'],
        'numberOfNotes': !exists(json, 'numberOfNotes') ? undefined : json['numberOfNotes'],
        'lastModified': !exists(json, 'lastModified') ? undefined : (new Date(json['lastModified'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'isPaidCurrentYear': !exists(json, 'isPaidCurrentYear') ? undefined : json['isPaidCurrentYear'],
        'isPaidLastYear': !exists(json, 'isPaidLastYear') ? undefined : json['isPaidLastYear'],
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesMemberStatusFromJSON(json['status']),
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
        'memberType': !exists(json, 'memberType') ? undefined : WebApiModelsEnumerationTypesMemberTypeFromJSON(json['memberType']),
        'primaryMemberId': !exists(json, 'primaryMemberId') ? undefined : json['primaryMemberId'],
        'personalNumber': !exists(json, 'personalNumber') ? undefined : json['personalNumber'],
        'phoneNumber2': !exists(json, 'phoneNumber2') ? undefined : json['phoneNumber2'],
        'phoneNumber2Formatted': !exists(json, 'phoneNumber2Formatted') ? undefined : json['phoneNumber2Formatted'],
        'adressRow2': !exists(json, 'adressRow2') ? undefined : json['adressRow2'],
        'adressRow3': !exists(json, 'adressRow3') ? undefined : json['adressRow3'],
        'joinedDate': !exists(json, 'joinedDate') ? undefined : (json['joinedDate'] === null ? null : new Date(json['joinedDate'])),
        'webPage': !exists(json, 'webPage') ? undefined : json['webPage'],
        'customFieldValues': !exists(json, 'customFieldValues') ? undefined : (json['customFieldValues'] === null ? null : (json['customFieldValues'] as Array<any>).map(WebApiMemberDtoCustomMemberFieldValueDtoFromJSON)),
        'membershipProduct': !exists(json, 'membershipProduct') ? undefined : json['membershipProduct'],
        'membershipProductAddOn': !exists(json, 'membershipProductAddOn') ? undefined : json['membershipProductAddOn'],
        'customListConnections': !exists(json, 'customListConnections') ? undefined : (json['customListConnections'] === null ? null : (json['customListConnections'] as Array<any>).map(WebApiMemberDtoCustomListConnectionDtoFromJSON)),
    };
}

export function WebApiMemberDtoMemberDtoToJSON(value?: WebApiMemberDtoMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'email2': value.email2,
        'unconfirmedEmail': value.unconfirmedEmail,
        'address': value.address,
        'postalCode': value.postalCode,
        'paymentLink': value.paymentLink,
        'paymentLinkId': value.paymentLinkId,
        'invoiceUrl': value.invoiceUrl,
        'paymentLinkLastYear': value.paymentLinkLastYear,
        'paymentLinkIdLastYear': value.paymentLinkIdLastYear,
        'invoiceUrlLastYear': value.invoiceUrlLastYear,
        'paymentLinkNextYear': value.paymentLinkNextYear,
        'paymentLinkIdNextYear': value.paymentLinkIdNextYear,
        'invoiceUrlNextYear': value.invoiceUrlNextYear,
        'isPaidNextYear': value.isPaidNextYear,
        'postalArea': value.postalArea,
        'country': value.country,
        'phoneNumber': value.phoneNumber,
        'phoneNumberFormatted': value.phoneNumberFormatted,
        'company': value.company,
        'uniqueId': value.uniqueId,
        'title': value.title,
        'extra1': value.extra1,
        'extra2': value.extra2,
        'extra3': value.extra3,
        'groups': value.groups,
        'groupNames': value.groupNames,
        'numberOfNotes': value.numberOfNotes,
        'lastModified': value.lastModified === undefined ? undefined : (value.lastModified.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'isPaidCurrentYear': value.isPaidCurrentYear,
        'isPaidLastYear': value.isPaidLastYear,
        'status': WebApiModelsEnumerationTypesMemberStatusToJSON(value.status),
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
        'memberType': WebApiModelsEnumerationTypesMemberTypeToJSON(value.memberType),
        'primaryMemberId': value.primaryMemberId,
        'personalNumber': value.personalNumber,
        'phoneNumber2': value.phoneNumber2,
        'phoneNumber2Formatted': value.phoneNumber2Formatted,
        'adressRow2': value.adressRow2,
        'adressRow3': value.adressRow3,
        'joinedDate': value.joinedDate === undefined ? undefined : (value.joinedDate === null ? null : value.joinedDate.toISOString().substr(0,10)),
        'webPage': value.webPage,
        'customFieldValues': value.customFieldValues === undefined ? undefined : (value.customFieldValues === null ? null : (value.customFieldValues as Array<any>).map(WebApiMemberDtoCustomMemberFieldValueDtoToJSON)),
        'membershipProduct': value.membershipProduct,
        'membershipProductAddOn': value.membershipProductAddOn,
        'customListConnections': value.customListConnections === undefined ? undefined : (value.customListConnections === null ? null : (value.customListConnections as Array<any>).map(WebApiMemberDtoCustomListConnectionDtoToJSON)),
    };
}

